import { SnapshotType } from '@upright/common/model/versions/types';
import { useGetAvailableVersions } from '@upright/ui/api/model/versions';
import ExclamationCircleIcon from '@upright/ui/common/generic/components/icons/hero-icons/hi-exclamation-circle.svg';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import styled from 'styled-components';
import { TippyWithOriginalStyles } from '../../../../tooltips/default-tippy';

interface Props {
  selectedVersionNumber: string;
}

export const VersionWarning = (props: Props) => {
  const { selectedVersionNumber } = props;
  const { data: availableVersions } = useGetAvailableVersions();

  if (!availableVersions) {
    return <></>;
  }

  const selectedVersion = availableVersions.find(version => version.number === selectedVersionNumber);

  if (selectedVersion === undefined) {
    return (
      <Root>
        <TippyWithOriginalStyles
          trigger={'mouseenter focus'}
          interactive={true}
          content={<span>Product data version {selectedVersionNumber} was not found.</span>}
          placement="bottom"
        >
          <div>
            <ExclamationCircleIcon />
          </div>
        </TippyWithOriginalStyles>
      </Root>
    );
  }

  if (selectedVersion.type === SnapshotType.DELETED) {
    return (
      <Root>
        <TippyWithOriginalStyles
          trigger={'mouseenter focus'}
          interactive={true}
          content={
            <span>Product data version {selectedVersion.number} is not available because it has been deleted.</span>
          }
          placement="bottom"
        >
          <div>
            <ExclamationCircleIcon />
          </div>
        </TippyWithOriginalStyles>
      </Root>
    );
  }
  return <></>;
};

const Root = styled.div`
  svg {
    height: 17px;
    margin-top: 4px;
  }
  /**
  ET note: hacky workaround to styles in src/ui/common/generic/components/bou-tool-header/desktop-header/items/index.tsx
   */
  * {
    &:hover,
    &:active {
      color: ${BouColor.TOOL_TEXT_WHITE} !important; // RN: even hackier addition. Seemed to be needed due to the above.
    }
  }
`;
